import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Wrench } from "lucide-react";
import { useApplications } from "@/lib/queries";
import SectionHeading from "@/components/SectionHeading";
import { Reveal } from "@/components/Reveal";

export default function CaseStudiesSection() {
  const { data: items = [] } = useApplications();
  if (!items.length) return null;

  return (
    <section data-testid="case-studies-section" className="bg-black py-24 sm:py-32">
      <div className="container-x">
        <div className="flex flex-col items-start justify-between gap-8 sm:flex-row sm:items-end">
          <SectionHeading
            number="04"
            overline="Uygulamalar"
            title="Gerçek araçlar, gerçek sonuçlar"
            subtitle="Atölyemizden geçen premium araçların dönüşüm hikâyeleri."
          />
          <Link
            to="/uygulamalar"
            className="group hidden shrink-0 items-center gap-2 border border-white/15 px-6 py-3.5 font-oswald text-xs uppercase tracking-[0.2em] text-white transition-colors hover:border-gold/50 hover:text-gold sm:inline-flex"
          >
            Tümünü Gör <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Link>
        </div>

        <div className="mt-14 grid gap-3 md:grid-cols-2 lg:grid-cols-3">
          {items.slice(0, 3).map((c, i) => {
            const vehicle = `${c.brand || ""} ${c.model || ""}`.trim() || c.title;
            const serviceLine = (c.services || []).join(" + ");
            return (
            <Reveal key={c.slug} delay={i * 0.08}>
              <Link
                to={`/uygulamalar/${c.slug}`}
                data-testid={`case-card-${c.slug}`}
                className="group block h-full overflow-hidden border border-white/10 bg-neutral-900 transition-colors hover:border-gold/40"
              >
                <div className="relative aspect-[16/11] overflow-hidden">
                  {(c.cover_image || c.after_image) ? (
                    <img src={c.cover_image || c.after_image} alt={c.title} loading="lazy" className="h-full w-full object-cover grayscale-[0.2] transition-all duration-700 group-hover:scale-105 group-hover:grayscale-0" />
                  ) : (
                    <div className="flex h-full w-full flex-col items-center justify-center gap-2 bg-gradient-to-b from-neutral-900 to-black">
                      <span className="px-4 text-center font-oswald text-2xl font-bold uppercase tracking-[0.2em] text-white/10">{c.brand}</span>
                      <span className="font-oswald text-[10px] uppercase tracking-[0.25em] text-gold/60">Fotoğraflar Yakında</span>
                    </div>
                  )}
                  <div className="absolute inset-0 bg-gradient-to-t from-neutral-900 via-neutral-900/30 to-transparent" />
                  {c.year && <span className="absolute left-4 top-4 border border-gold/40 bg-black/70 px-3 py-1 font-oswald text-[11px] font-bold uppercase tracking-[0.15em] text-gold backdrop-blur">{c.year} Model</span>}
                  <span className="absolute right-4 top-4 font-oswald text-sm font-bold tracking-[0.2em] text-white/40">{String(i + 1).padStart(2, "0")}</span>
                </div>
                <div className="p-6">
                  {serviceLine && <span className="font-oswald text-[11px] font-bold uppercase tracking-[0.18em] text-gold">{serviceLine}</span>}
                  <h3 className="mt-1.5 font-display text-lg font-medium text-white transition-colors group-hover:text-gold">{vehicle}</h3>
                  <p className="mt-2 text-sm text-neutral-400 line-clamp-2">{c.summary}</p>
                  <div className="mt-5 flex flex-wrap gap-4 border-t border-white/10 pt-4 text-xs text-neutral-500">
                    {c.duration && <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 text-gold" /> {c.duration}</span>}
                    {c.services?.length > 0 && <span className="flex items-center gap-1.5"><Wrench className="h-3.5 w-3.5 text-gold" /> {c.services.length} hizmet</span>}
                  </div>
                </div>
              </Link>
            </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
